module.exports = __webpack_public_path__ + "img/icon_point2-10.3b459af6.svg";